import React from 'react'
import { Trans, useTranslation } from 'react-i18next';

const base_url = process.env.REACT_APP_BASE_URL;

const CourseRegistrationSuccess = () => {
    const { t } = useTranslation();
    return (
        <div className='payment-success'>
            <div className='d-flex justify-content-center'>
                <img src={`${base_url}/images/accept.png`} alt="" />
            </div>
            <div className='text-center mx-5 mt-3' style={{ maxWidth: "550px" }}>
                <p><strong>{t("registration.successTitle")}</strong></p>
                <p>
                    <Trans html="br:<br/>">
                        {t("registration.successDescription")}

                        <span style={{ color: "#2b28adff" }}>
                            {t("registration.successDescriptionContact")}
                        </span>
                    </Trans>
                </p>
            </div>

        </div>
    );
}

export default CourseRegistrationSuccess